import * as angular from 'angular';
import {StateProvider} from '@uirouter/angularjs';
import {ReceiveController} from "./ReceiveController";
import {ManageController} from "./ManageController";
import {AuthNetHostedProfilePageModeType} from "../../model/AuthNetHostedProfilePageModeType";
import {CardMigrationController} from "./CardMigration";
import {UnlinkedProfileController} from "./UnlinkedProfileController";
import BatchController from "./BatchController";
import UnlinkedTransactionController from "./UnlinkedTransactionController";
import TransactionsWithoutPaymentProfileController from "./TransactionsWithoutPaymentProfileController";
import ViewController from "./ViewController";

class Routes {
    static $inject = ['$stateProvider'];

    constructor($stateProvider: StateProvider) {
        $stateProvider
            .state('payment', {abstract: true})
            .state('payment.receive', {
                url: '/payment/receive?{customerGuid}',
                params: {
                    customerGuid: {value: null, isOptional: true, dynamic: true}
                },
                template: require('./Receive.html'),
                controller: ReceiveController,
                controllerAs: 'vm',
                data: {title: 'Receive Payment'}
            })
            .state('payment.manage', {
                url: '/payment/manage?{customerGuid}&{gatewayGuid}&{mode:int}&{paymentProfileId}&{skipValidation:bool}',
                params: {
                    gatewayGuid: null,
                    mode: AuthNetHostedProfilePageModeType.Manage,
                    paymentProfileId: null,
                    skipValidation: false
                },
                template: require('./Manage.html'),
                controller: ManageController,
                controllerAs: 'vm',
                data: {title: 'Manage Payment Cards'}
            })
            .state('payment.migration', {
                url: '/payment/migration',
                template: require('./CardMigration.html'),
                controller: CardMigrationController,
                controllerAs: 'vm',
                data: {title: 'Card Migration'}
            })
            .state('payment.unlinkedProfile', {
                url: '/payment/unlinkedProfile',
                template: require('./UnlinkedProfile.html'),
                controller: UnlinkedProfileController,
                controllerAs: 'vm',
                data: {title: 'Unlinked Customer Profiles'}
            })
            .state('payment.unlinkedTransaction', {
                url: '/payment/unlinkedTransaction',
                template: require('./UnlinkedTransaction.html'),
                controller: UnlinkedTransactionController,
                controllerAs: 'vm',
                data: {title: 'Unlinked Transaction'}
            })
            .state('payment.transactionsWithoutPaymentProfile', {
                url: '/payment/transactionsWithoutPaymentProfile',
                template: require('./TransactionsWithoutPaymentProfile.html'),
                controller: TransactionsWithoutPaymentProfileController,
                controllerAs: 'vm',
                data: {title: 'Transactions Without Payment Profile'}
            })
            .state('payment.batch', {
                url: '/payment/batch',
                template: require('./Batch.html'),
                controller: BatchController,
                controllerAs: 'vm',
                data: {title: 'Batches'}
            })
            .state('payment.view', {
                url: '/payment/view/:paymentGuid',
                template: require('./View.html'),
                controller: ViewController,
                controllerAs: 'vm',
                data: {title: 'Payment View'}
            })


    }
}

export default angular.module('app.payment', [])
    .config(Routes)
    .name;
